import { SelectionMode } from '@uifabric/utilities'
import {
  EntityList,
  EntityListProps,
  renderInvertedYesNoIcon,
  renderPersona,
  renderTimeAgo,
} from 'components/EntityList'
import { GdprRule } from 'model'
import { ConstrainMode, PersonaSize } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type DsgvoListProps = EntityListProps<GdprRule>

export const DsgvoList: React.FC<DsgvoListProps> = ({ items, ...props }) => {
  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])

  const columns = React.useMemo(
    () => [
      fieldColumn('inactive', {
        name: t('field.active.label'),
        onRender: renderInvertedYesNoIcon,
        ungroupable: true,
      }),
      fieldColumn('ruleName', {
        minWidth: 300,
        ungroupable: true,
        isSorted: true,
      }),
      fieldColumn('retentionPeriod', {
        onRender: (item) => `${item.retentionPeriod} Tage`,
        minWidth: 100,
        ungroupable: true,
      }),
      fieldColumn('deletionPeriod', {
        onRender: (item) => `${item.deletionPeriod} Jahre`,
        ungroupable: true,
      }),
      fieldColumn('createdBy', {
        onRender: renderPersona({
          size: PersonaSize.size8,
        }),
        minWidth: 155,
        ungroupable: true,
      }),
      fieldColumn('created', { onRender: renderTimeAgo, ungroupable: true }),
      fieldColumn('modifiedBy', {
        onRender: renderPersona({
          size: PersonaSize.size8,
        }),
        minWidth: 155,
        ungroupable: true,
      }),
      fieldColumn('modified', { onRender: renderTimeAgo, ungroupable: true }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.single}
      constrainMode={ConstrainMode.horizontalConstrained}
      items={items}
      columns={columns}
      {...props}
    />
  )
}
